import {CURSOR_MARK, MarkedInput, Options} from './types';

const GROUP_SIZE = 3;
const groupDigits = (input: MarkedInput, {groupSeparator}: Options): MarkedInput =>
  input.reduceRight((grouped, char, i) => {
    if (!grouped.length) return [char];
    // always move mark to next group by adding groupSeparator
    // unless mark is the last char (i === 0)
    // don not account for mark when calculating group size
    const groupSizeChunk = (GROUP_SIZE + groupSeparator.length);
    const groupSizeWithoutMark = grouped.length + groupSeparator.length - Number(grouped.includes(CURSOR_MARK));
    if ((char !== CURSOR_MARK || i !== 0) && groupSizeWithoutMark % groupSizeChunk === 0) {
      grouped = [...groupSeparator, ...grouped];
    }
    return [char, ...grouped];
  }, []);

export default groupDigits;
